import { render, staticRenderFns } from "./ModalPrecioMasivo.vue?vue&type=template&id=2df8d6c2&scoped=true"
import script from "./ModalPrecioMasivo.vue?vue&type=script&lang=js"
export * from "./ModalPrecioMasivo.vue?vue&type=script&lang=js"
import style0 from "./ModalPrecioMasivo.vue?vue&type=style&index=0&id=2df8d6c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df8d6c2",
  null
  
)

export default component.exports